// extracted by mini-css-extract-plugin
export default {"cls1":"LookupTextField-Surface_cls1__dRCjQ","cls2":"LookupTextField-Surface_cls2__nOUfv LookupTextField-Surface_cls1__dRCjQ","adjust":"LookupTextField-Surface_adjust__aabhA"};